import { render } from "./FrateComunita.vue?vue&type=template&id=260564b2"
import script from "./FrateComunita.vue?vue&type=script&lang=js"
export * from "./FrateComunita.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\fr201\\Google Drive\\Sites internet\\Lavigna\\lavigna\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__